"use client"

import { FormEvent, useState } from "react"
import { action_subscribeToBackInStock } from "src/actions/products"
import { getEmailErrorId } from "src/checkout/components/stages/contactForm/validation"
import { checkoutContactStore, mergeCheckoutBillingAddress } from "src/checkout/state/checkoutContactStore"
import { setGlobalErrorMessage } from "src/components/error/state"
import { NpButton } from "src/components/np-design/components/NpButton"
import { NpIcon } from "src/components/np-design/components/NpIcon"
import { NpInput } from "src/components/np-design/components/input/NpInput"
import { NpEmailPrivacy } from "src/components/np-design/sections/newsletter/NpEmailPrivacy"
import { recordError } from "src/utilities/errorReporting"

export type BackInStockSignupFormProps = {
  sku: string
  onSuccess: () => void
}

export const BackInStockSignupForm = ({ sku, onSuccess }: BackInStockSignupFormProps) => {
  const email = checkoutContactStore((state) => state.billingAddress.email)
  const [opened, setOpened] = useState(false)
  const [loading, setLoading] = useState(false)

  function handleEmailChange(value: string) {
    const billingAddress = checkoutContactStore.getState().billingAddress
    const error = getEmailErrorId(value)
    const focused = billingAddress.email.focused

    mergeCheckoutBillingAddress({ email: { value, error, focused } })
  }

  async function handleSubmit(event: FormEvent) {
    event.preventDefault()

    try {
      setLoading(true)
      await action_subscribeToBackInStock({ sku, email: email.value })
      onSuccess()
    } catch (error) {
      recordError("Failed to subscribe to back in stock for " + sku, error)
      setGlobalErrorMessage("Fehler bei der Anmeldung. Bitte versuche es später erneut.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} inert={loading} className="flex flex-col items-center gap-6 text-center">
      <div className="text-np-green flex items-center gap-4 text-left leading-tight">
        <NpIcon name="outgoing_mail" className="size-8" />
        <span>Werde benachrichtigt, wenn das Produkt wieder verfügbar ist:</span>
      </div>

      {!opened ? (
        <NpButton type="button" onClick={() => setOpened(true)}>
          Info erhalten
        </NpButton>
      ) : (
        <div className="flex w-full flex-col gap-4">
          <NpInput
            type="email"
            autoComplete="home email"
            placeholder="Deine E-Mail"
            required
            value={email.value}
            onChange={handleEmailChange}
          />

          <NpEmailPrivacy />

          <NpButton type="submit" disabled={!!getEmailErrorId(email.value)} loading={loading}>
            Anmelden
          </NpButton>
        </div>
      )}
    </form>
  )
}
